import { render, staticRenderFns } from "./dashboard-layout.vue?vue&type=template&id=2dd42018&scoped=true&"
import script from "./dashboard-layout.vue?vue&type=script&lang=js&"
export * from "./dashboard-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd42018",
  null
  
)

export default component.exports